import React from "react";
import  { useState, useEffect } from 'react';
import './classes/HockeyEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const JensCastenTestimonial = () => {
     
    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        Promise.all([
          
        ])
        .then(() => {
     
        setIsLoading(false);
        })
    },[]);

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };
   

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" style={{minHeight: "400px"}} className="jens-casten-testimonial-main">
                <Helmet><title>Jens Casten</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div style={{float: "left"}}>
                        <img src="/basic/web/images/scout/picture-1105-1441602821.jpg" alt="Jens Casten" />
                    </div>
                    <div style={{float:"left", paddingLeft:"2%", paddingTop:"2%"}}><strong>Jens Casten</strong></div>
                    <div style={{textAlign: "right"}}><a href onClick={doBackAway} style={{cursor: "pointer"}}>« Back</a></div>
                    <div style={{clear:"both"}}></div>
                    <div style={{marginBottom: "8px"}}>
                        <p style={{marginTop: "0px"}}>
                            I was a Pro Goalie for 21 years and had to retire suddenly due to an injury, without any direction concerning my future career. 
                            I was immediately impressed with the SMWW concept and felt that enrolling in their educational programs could be greatly beneficial to my professional future off the ice. 
                            SMWW online education is the way of the future bringing the sports world together. 
                            SMWW chats provide an excellent forum for the exchange of ideas and relating of experience, and networking with people from all over the globe. 
                            I have just completed the Agent Management Course and will stay with SMWW as an Agent Advisor. 
                            I have also enrolled in the Hockey General Manger Course and am looking forward to the guidance of SMWW and EJ Hradek. 
                            I wish I had come across SMWW 10 years ago. 
                            Dr. Lashbrook is a great mentor with impressive knowledge and leadership.
                        </p>
                    </div>
                </div>
                <div className="right">
                       {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default JensCastenTestimonial;